import { IsUUID } from 'class-validator'

export class BaseParametersDTO {
  @IsUUID()
  id: string
}
